import { t } from 'ttag';
import { addMethod, date, setLocale, string } from 'yup';

addMethod(
  string,
  'cyrillic',
  function (message = t`Поле може містити лише літери кирилиці`) {
    return this.test('cyrillic', message, (value) => {
      if (!value) return true;

      return /^[А-ЯІЇЄҐа-яіїєґ\s]+$/.test(value);
    });
  },
);

addMethod(
  string,
  'nonArithmetic',
  function (message = t`Поле може містити лише літери`) {
    return this.test('nonArithmetic', message, (value) => {
      if (!value) return true;

      if (Number.isNaN(Number(value))) return true;

      return /^[^0-9]+$/.test(value);
    });
  },
);

addMethod(string, 'phone', function (message = t`Невалідний номер телефону`) {
  return this.test('phone', message, (value) => {
    if (!value) return true;

    return /^[+]?[0-9]{10,13}$/.test(value);
  });
});

addMethod(
  string,
  'arithmetic',
  function (message = t`Поле може містити лише цифри`) {
    return this.test('arithmetic', message, (value) => {
      if (!value) return true;

      if (Number.isNaN(Number(value))) return false;

      return /^[0-9.,\-+/*()%^e]+$/.test(value);
    });
  },
);

addMethod(string, 'ipn', function (message = t`ІПН має складатися з 10 цифр`) {
  return this.test('ipn', message, (value) => {
    if (!value) return true;

    return /^[0-9]{10}$/.test(value);
  });
});

addMethod(
  string,
  'passport',
  function (message = t`Серія та номер паспорту вказано не правильно`) {
    return this.test('passport', message, (value) => {
      if (!value) return true;

      return /^[A-Za-zА-ЯІЇЄҐа-яіїєґ]{2}[0-9]{6}$/.test(value);
    });
  },
);
addMethod(string, 'ipnOrPassport', function (message) {
  return this.test('ipnOrPassport', function (value) {
    if (!value) return true;

    const firstChar = value.charAt(0);

    if (/[0-9]/.test(firstChar)) {
      const isValid = string().ipn().isValidSync(value);

      if (isValid) return true;

      return this.createError({
        message: message || t`ІПН має складатися з 10 цифр`,
      });
    }

    const isValid = string().passport().isValidSync(value);

    if (isValid) return true;

    return this.createError({
      message: message || t`Серія та номер паспорту вказано не правильно`,
    });
  });
});

addMethod(string, 'edrpou', function (message = t`Невалідний ЄДРПОУ`) {
  return this.test('edrpou', message, (value) => {
    if (!value) return true;

    return /^[0-9]{8,10}$/.test(value);
  });
});

addMethod(string, 'upperFirstLetter', function () {
  return this.transform((value) => {
    if (!value) return value;

    return value.charAt(0).toUpperCase() + value.slice(1);
  });
});

addMethod(string, 'fullName', function (message) {
  return this.test('fullName', function (value) {
    if (!value) return true;

    const words = value.trim().split(/\s+/);

    if (words.some((word) => word.length >= 50)) {
      return this.createError({
        message: t`Слово не може бути довшим ніж 50 символів`,
      });
    }

    if (message) {
      return words.length === 3 || this.createError({ message });
    }

    if (words.length < 1) {
      return this.createError({ message: t`Вкажіть ПІБ` });
    }

    if (words.length === 1) {
      return this.createError({ message: t`Вкажіть ім'я та по батькові` });
    }

    if (words.length === 2) {
      return this.createError({ message: t`Вкажіть по батькові` });
    }

    if (words.length > 3) {
      return this.createError({ message: t`ПІБ має складатися з трьох слів` });
    }

    return true;
  });
});

addMethod(string, 'emptyToNull', function () {
  return this.transform((value) => {
    return value || null;
  });
});

addMethod(date, 'invalidToNull', function () {
  return this.transform((value) => {
    if (!value) return null;

    const date = new Date(value);

    if (date.toString() === 'Invalid Date') {
      return null;
    }

    return date;
  });
});

setLocale({
  mixed: {
    required: t`Обов'язкове поле`,
    default: t`Некоректно введені дані`,
    notType: t`Очікується інший тип даних`,
  },
  string: {
    matches: t`Поле заповнено некорректно`,
    email: t`Невалідний email`,
    url: t`Невалідна URL адреса`,
    max: t`Максимальна довжина текстового поля \${max} символів`,
  },
  number: {
    max: t`Максимальне значення \${max}`,
    min: t`Мінімальне значення \${min}`,
    lessThan: t`Не може бути більше ніж \${less}`,
    moreThan: t`Значення має бути більше ніж \${more}`,
    integer: t`Число має бути цілим`,
  },
});
